/**
 * @copyright WaterStreet. All rights reserved.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

import {
	ChangeDetectorRef,
	Component,
	OnInit
} from '@angular/core';
import {
	ExtendedCustomControlDirective
} from '@entity/directives/extended-custom-control.directive';
import {
	AnyHelper
} from '@shared/helpers/any.helper';
import {
	StringHelper
} from '@shared/helpers/string.helper';
import {
	get
} from 'lodash-es';

@Component({
	selector: 'custom-input-switch',
	templateUrl: './custom-input-switch.component.html',
	styleUrls: [
		'./custom-input-switch.component.scss'
	]
})

/**
 * A component representing an instance of a Custom Input Switch.
 * https://ngx-formly.github.io/ngx-formly/guide
 *
 * @export
 * @class CustomInputSwitchComponent
 * @extends {ExtendedCustomControlDirective}
 * @implements {OnInit}
 */
export class CustomInputSwitchComponent
	extends ExtendedCustomControlDirective
	implements OnInit
{
	/** Initializes a new instance of the CustomInputSwitchComponent.
	 *
	 * @param {ChangeDetectorRef} changeDetector
	 * The change detector reference for this component.
	 * @memberof CustomInputSwitchComponent
	 */
	public constructor(
		public changeDetector: ChangeDetectorRef)
	{
		super(changeDetector);
	}

	/**
	 * Gets or sets inputgroup items.
	 *
	 * @type {any[]}
	 * @memberof CustomInputSwitchComponent
	 */
	public inputGroupItems: any[];

	/**
	 * Handles the on initialization interface.
	 * This will capture the saved input switch boolean, and pass
	 * it to the displayInput value. Also saves the model into a
	 * separate data model constant.
	 *
	 * @memberof CustomInputSwitchComponent
	 */
	public ngOnInit(): void
	{
		if (!AnyHelper.isNullOrEmpty(
			this.field.props.inputGroupItems))
		{
			this.inputGroupItems =
				this.field.props.useInputGroupFunction
					!== true
					? this.field.props.inputGroupItems
					: StringHelper
						.transformToFunction(
							this.field.props.inputGroupItems,
							this.field.props.context)(this.model);

			if (AnyHelper.isNull(this.formControl.value))
			{
				this.formControl.setValue([]);
			}
		}

		super.ngOnInit();
	}

	/**
	 * Handles standalone input switch changes by firing the change event.
	 *
	 * @param {any} event.
	 * The change event.
	 * @memberof CustomInputSwitchComponent
	 */
	public handleInputChanges(
		event: any): void
	{
		if (AnyHelper.isFunction(this.field.props.change))
		{
			this.field.props.change(
				this.field,
				event);
		}
	}

	/**
	 * Handles input group input switch changes
	 * by adding or removing values from the formControl
	 *
	 * @param {any} event.
	 * The change event.
	 * @param {any} changedValue
	 * The changed value key.
	 * @memberof CustomInputSwitchComponent
	 */
	public handleInputGroupChanges(
		event: any,
		changedValue: any): void
	{
		const inputGroupKey =
			this.field.props.inputGroupKey;

		this.formControl.setValue(
			event.checked === true
				? [
					...this.formControl.value,
					changedValue
				]
				: this.formControl.value
					.filter((currentValue: any) =>
						get(currentValue, inputGroupKey)
							!== get(changedValue, inputGroupKey)));
	}
}